import { inject } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from './toast.service';

export const responseInterceptor = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
	const router = inject(Router);
	const toastService = inject(ToastService);

	return next(request).pipe(
		catchError((error: any) => {
			if (error instanceof HttpErrorResponse) {
				if (error.status === 401) {
					router.navigate(['/error/401']);
				}
				if (error.status >= 400) {
					console.error('Erro HTTP:', error.message || error.statusText);
				}
				if (error.status === 201) {
					return throwError(() => true);
				}
				if (error.status === 0) {
					toastService.error('toast_error_server', 'Error');
					return EMPTY;
				}
			}
			return throwError(() => error);
		})
	);
};
